let init = {
    userRoomsList: {
        userRoomsListTable: [],
        limit: 10,
        page: 0,
        totalDocs: 0,
        totalPages: 0
    },
};

const userRoomsReducer = (state = init, { type, payload }) => {
    switch (type) {
        case 'GET_USER_ROOMS_LIST': {
            return {
                ...state,
                userRoomsList: {
                    userRoomsListTable: payload?.docs || [],
                    totalDocs: payload?.totalDocs || 0,
                    totalPages: payload?.totalPages || 0,
                    limit: payload?.limit || 10,
                    page: (payload?.page || 1) - 1
                }
            };
        }
        default: {
            return state;
        }
    }
};

export default userRoomsReducer;
